import { TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type Duration = {
  minutes: number
  seconds: number
}

const reducerAction = {
  minutes: actionCreatorTypeGuard<Duration, number>("minutes", "Duration"),
  seconds: actionCreatorTypeGuard<Duration, number>("seconds", "Duration"),
  __record: actionCreatorTypeGuard<TypeArray, Duration>("Duration", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null>(
    "create",
    "__create/Duration"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof Duration
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const durationAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const durationReducer = reducerTypeGuard<Duration>()
  .case(...reducerAction.minutes)
  .case(...reducerAction.seconds)
  .build()
